import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarHeaderComponent } from 'src/app/modules/bdc/shared/calendar/calendar-header/calendar-header.component';
import { assetUrl } from 'src/single-spa/asset-url';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import {
  IHoliday, DayType, IEmployee, IAbsenceRecordYearWise, LeaveType, IEmployeeLeaveDetail, DayTime
} from '@signal/asp-data-commons';
import { selectHolidays } from 'src/app/modules/store/holiday/holiday.adapter';
import { Store } from '@ngrx/store';
import { HolidayState } from 'src/app/modules/store/holiday/holiday.reducer';
import { EmployeeState } from 'src/app/modules/store/employee/employee.reducer';
import * as fromEmployeeActions from './../../../store/employee/employee.actions';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { LuxonDateAdapter } from '../../services/luxon-date-adapter';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { AddLeavesService } from '../../services/add-leaves.service';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../models/asp.types';
import { unsubscribeSubscriptions } from '../../services/util.service';
@Component({
  selector: 'app-add-leaves',
  templateUrl: './add-leaves.component.html',
  styleUrls: ['./add-leaves.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }

  ],
  encapsulation: ViewEncapsulation.None
})
export class AddLeavesComponent implements OnInit, OnDestroy {
  @ViewChild('leavecalendar', { static: false }) calendar: MatCalendar<DateTime>;
  @ViewChild('leavecalendar', { read: ElementRef }) calendarRef: ElementRef;
  title = this.translate.instant('servicePersonnel.upcomingDayOffs');
  selectedDate = DateTime.now();
  daysSelected: any[] = [];
  customHeader = CalendarHeaderComponent;
  dayType: DayType;
  dayTime: DayTime;
  holidays$: Observable<IHoliday[]>;
  leaveType: LeaveType;
  leaves = [];
  leaveDetailsYearWise: IAbsenceRecordYearWise[] = [];
  isDeleteButtonEnable: boolean = true;
  isDataDeleted: boolean = false;
  lowCapacityUrl = assetUrl('icons/capacity-indicators/low-capacity.svg');
  minDate: string;
  dateFormat : string = 'yyyy-MM-dd';
  @ViewChild('form') form: ElementRef;
  clickedOutside=false;
  private subs: SubscriptionList = {};

  constructor(public dialogRef: MatDialogRef<AddLeavesComponent>,
    private translate : TranslateService,
    private readonly holidayState: Store<HolidayState>,
    private readonly employeeStore: Store<EmployeeState>,
    private dialog: MatDialog,
    private addLeaveService: AddLeavesService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.minDate = DateTime.now().toFormat(this.dateFormat);
    this.leaves = [{ name: 'Day-off' }, { name: 'Training'},
                   { name: "Weekly" }, { name: "Biweekly" }, { name: "Monthly"}];
    this.dayTime = DayTime.am;
  }

  ngOnInit() {
    this.addLeaveService.getEmployeeLeaveDetails(this.data, this.minDate);
    this.setUpStore();
  }
  
  @HostListener("document:click", ['$event.target'])
  showMessage(event)
  {    
    if (!this.form.nativeElement.contains(event))
    if( this.data.clicked) {
      this.data.clicked=false;
    }
    else{
      this.clickedOutside=true;
    }
  }
  
  dateClass = (event: any) => {
    let classname = '';
    const date = event.toFormat(this.dateFormat);
    const uniquelist = [...this.addLeaveService.trainingList, ...this.addLeaveService.dayOffList, ...this.addLeaveService.weeklyLeaveList, ...this.addLeaveService.biWeeklyLeaveList, ...this.addLeaveService.monthlyLeaveList].filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
    const leavelist = uniquelist.find(leave => leave.leaveDate === date);
    const length = this.addLeaveService.recurrentLeaveList.length;
    if ((leavelist === undefined || leavelist.dayType === DayType.half) &&
      this.addLeaveService.dealerShipHoliday.find(holiday => holiday.date == date && holiday.dayType !== "HALF") === undefined) {
      for (let i = length - 1; i >= 0; i--) {
        if ((this.addLeaveService.recurrentLeaveList[i].endDate && new Date(date) >= new Date(this.addLeaveService.recurrentLeaveList[i].leaveDate) && new Date(date) <= new Date(this.addLeaveService.recurrentLeaveList[i].endDate)) || ((this.addLeaveService.recurrentLeaveList[i].endDate === '' || this.addLeaveService.recurrentLeaveList[i].endDate === null  || !this.addLeaveService.recurrentLeaveList[i]?.endDate) && new Date(date) >= new Date(this.addLeaveService.recurrentLeaveList[i].leaveDate))){
          this.addLeaveService.calculateLeave(date, this.addLeaveService.recurrentLeaveList[i]);
        }
      }
    }
    const totalLeaveList = [...this.addLeaveService.trainingList, ...this.addLeaveService.dayOffList, ...this.addLeaveService.weeklyLeaveList, ...this.addLeaveService.biWeeklyLeaveList, ...this.addLeaveService.monthlyLeaveList].filter(leave => leave.leaveDate === date)
    if (totalLeaveList.length === 2) {
      for (const list of totalLeaveList) {
        classname += list.leaveType + list.dayTime;
      }
    } else {
      classname += this.addLeaveService.trainingList.find(x => x.leaveDate == date) ?
        this.addLeaveService.trainingList.find(x => x.leaveDate == date).dayTime ? this.addLeaveService.trainingList.find(x => x.leaveDate == date).dayTime + 'trainingleave' : 'NA' + 'trainingleave' :
        this.addLeaveService.dayOffList.find(x => x.leaveDate == date) ?
          this.addLeaveService.dayOffList.find(x => x.leaveDate == date).dayTime ? this.addLeaveService.dayOffList.find(x => x.leaveDate == date).dayTime + 'dayoffleave' : 'NA' +
            'dayoffleave' : (this.addLeaveService.weeklyLeaveList.find(x => x.leaveDate == date) ? this.addLeaveService.weeklyLeaveList.find(x => x.leaveDate == date).dayTime ? this.addLeaveService.weeklyLeaveList.find(x => x.leaveDate == date).dayTime + 'weeklyleave' : 'NA' + 'weeklyleave' :
              (this.addLeaveService.biWeeklyLeaveList.find(x => x.leaveDate == date) ? this.addLeaveService.biWeeklyLeaveList.find(x => x.leaveDate == date).dayTime ? this.addLeaveService.biWeeklyLeaveList.find(x => x.leaveDate == date).dayTime + 'biweeklyleave' : 'NA' + 'biweeklyleave' :
                (this.addLeaveService.monthlyLeaveList.find(x => x.leaveDate == date) ? this.addLeaveService.monthlyLeaveList.find(x => x.leaveDate == date).dayTime ? this.addLeaveService.monthlyLeaveList.find(x => x.leaveDate == date).dayTime + 'monthlyleave' : 'NA' + 'monthlyleave' : '')))
    }
    classname = classname ? classname : "class";
    classname += this.addLeaveService.dealerShipHoliday.find(x => x.date == date && x.dayType !== 'HALF') ? `dealershipholiday` : this.addLeaveService.dealerShipHoliday.find(x => x.date == date && x.dayType === 'HALF') ? `dealershipholiday${this.addLeaveService.dealerShipHoliday.find(x => x.date == date && x.dayType === 'HALF').dayTime}` : '';
    classname += this.daysSelected.find(x => x == date) ? " selected" : " ";
    return classname;
  };

  dateChange(event: any, calendar: any) {
    const date = event.toFormat(this.dateFormat);
    if (this.addLeaveService.dealerShipHoliday.findIndex(holiday => holiday.date === date && holiday.dayType !== "HALF") === -1) {
      const index = this.daysSelected.findIndex(x => x == date);
      if (index < 0){
        this.daysSelected.push(date);
      }
      else{
        this.daysSelected.splice(index, 1);
      }
      calendar.updateTodaysDate();
    }
    const leaveTypeFilteredArray = this.enableDeleteButton();
    const allEqual = arr => arr.every(val => val === arr[0])

    this.isDeleteButtonEnable = !((allEqual(leaveTypeFilteredArray) && this.daysSelected.length === leaveTypeFilteredArray.length) && (this.daysSelected.length > 0));
    if (this.daysSelected.length === 1 && leaveTypeFilteredArray.length === 1) {
      /* ---------------  update single day selection  ----------------*/
      this.updateLeaveTypeAndDayType()
    }
    if(this.addLeaveService.dealerShipHoliday.find(holiday=>holiday.date === date && holiday.dayType === DayType.half)){
      this.updateDayTypeAndDayType(this.addLeaveService.dealerShipHoliday.find(holiday=>holiday.date === date))
    }
  }
  updateLeaveTypeAndDayType() {
    const totallist = [...this.addLeaveService.trainingList, ...this.addLeaveService.dayOffList];
    if (totallist.find(leave => leave.leaveDate === this.daysSelected[0])?.dayType === DayType.half) {
      this.dayType = totallist.find(leave => leave.leaveDate === this.daysSelected[0]).dayType;
      this.dayTime = totallist.find(leave => leave.leaveDate === this.daysSelected[0]).dayTime;
    }
  }
  updateDayTypeAndDayType(holiday){
    this.dayType = DayType.half;
    this.dayTime = holiday.dayTime === DayTime.am ? DayTime.pm : DayTime.am;
  }
  saveEmployeeLeaveDetails(data?) {
    this.addLeaveService.getEmployeeLeaveDetails(this.data, this.minDate);
    const endDate = data?.selectedDate || null;
    for (const day of this.daysSelected) {
      this.addLeaveService.addLeaveExceptionalList( day, 'save', this.dayTime, this.leaveType, endDate);
    }
    if (this.dayType === DayType.full) {
      this.dayTime = DayTime.NA;
    }
    for (const day of this.daysSelected) {
      const holidayLeave = this.addLeaveService.dealerShipHoliday.find(holiday=>holiday.date === day )
      if(holidayLeave === undefined || this.dayTime !== "NA" && holidayLeave.dayTime !== this.dayTime ){
        this.updateLeaveDetails(day, endDate);
      }
    }
    if(this.data?.employee?.avatar === "undefined" || !this.data?.employee?.avatar){
      this.data = {
         ...this.data,
         employee: {
          ...this.data.employee,
          avatar: ''
         }
      };
    }
    const employee: IEmployee = {
      ... this.data.employee,
      employeeLeaveDetails: [...this.addLeaveService.leaveDetailsYearWise]
    }
    this.dispatchActions(employee);
    this.data = { employee: employee }
    this.addLeaveService.resetValues();
    this.addLeaveService.getEmployeeLeaveDetails(this.data, this.minDate);
    this.daysSelected = [];
    this.isDeleteButtonEnable = true;
    this.calendar.updateTodaysDate();
  }
  close() {
    this.dialogRef.close({ action: 'cancel' });
  }
  setLeaveType(value) {
    this.leaveType = value.toUpperCase();
  }
  onSave() {
    this.dayTime = this.dayType === DayType.full ? DayTime.NA : this.dayTime;
    if (this.leaveType.includes('LY')) { //to check if its recurrent leaves
      const date = this.daysSelected.length > 0 ? this.daysSelected.sort((x, y) => +new Date(x) - +new Date(y)) : this.daysSelected;
      this.openConfirmDialog('save', date[date.length - 1]);
    } else {
      this.saveEmployeeLeaveDetails();
    }
  }

  private dispatchActions(employee) {
    const employeeFormData = { ...employee };
    delete (employeeFormData.preSignedUrl);
    this.employeeStore.dispatch(new fromEmployeeActions.UpdateEmployee({ employee: { ...employeeFormData } }));
  }

  private updateLeaveDetails(day, endDate) {
    const data: IEmployeeLeaveDetail = {
      leaveDate: day,
      leaveType: this.leaveType,
      dayType: this.dayType,
      dayTime: this.dayTime,
      isRecurrentLeave: false
    };

    if (this.leaveType === LeaveType.weekly || this.leaveType === LeaveType.biweekly || this.leaveType === LeaveType.monthly) {
      data.isRecurrentLeave = true;
      data.endDate = endDate;
      data.exceptionalDates = [];
    }

    let leaveDetailsYear: IAbsenceRecordYearWise;
    const dateYear: number = this.leaveType.includes('LY') ? -1 : new Date(day).getFullYear();
    if (this.addLeaveService.leaveDetailsYearWise.length > 0 && this.addLeaveService.leaveDetailsYearWise.find(x => x.year === dateYear)) {
      this.addLeaveService.leaveDetailsYearWise = this.addLeaveService.leaveDetailsYearWise.filter(
        leave => {
          if (leave.year === dateYear) {
            const index = leave.leaveDetails.findIndex(leaveDetail =>
              leaveDetail.leaveDate === data.leaveDate &&
              leaveDetail.leaveType === data.leaveType
              && leaveDetail.dayType === DayType.half &&
              leaveDetail.dayType === data.dayType &&
              leaveDetail.dayTime !== data.dayTime)
            if (index > -1) {
              leave.leaveDetails.splice(index, 1);
              data.dayType = DayType.full;
              data.dayTime = DayTime.NA;
            }
            leave.leaveDetails.push(data);
            return leave;
          }
          else {
            return leave;
          }
        })
    }
    else {
      const leaveDetails = []
      leaveDetails.push(data);
      leaveDetailsYear = {
        year: dateYear,
        leaveDetails: leaveDetails
      }
      this.addLeaveService.leaveDetailsYearWise.push(leaveDetailsYear);
    }
  }

  isValidForm() {
    if (this.isDataDeleted) {
      return false;
    }
    return !(this.daysSelected.length > 0 &&
      this.leaveType?.length > 0 &&
      this.dayType?.length > 0)
  }
  private setUpStore() {
    this.holidays$ = this.holidayState.select(selectHolidays);
    this.subs.holiday = this.holidays$.subscribe(dealershipholidaylist => {
      if (dealershipholidaylist && dealershipholidaylist.length > 0) {
        for (const holiday of dealershipholidaylist) {
          this.addLeaveService.dealerShipHoliday.push({
            date : holiday.holidayDate,
            dayType: holiday.dayType,
            dayTime: holiday.dayTime
          });
        }
        this.calendar.updateTodaysDate();
      }
    })
  }
  openConfirmDialog(key, daySelected?) {
    const data = { key, popupTitle: '', popupBodyText: '', options: [], dateSelected: '' };
    let width = '400px';
    if (key === 'delete') {
      const isRecurringLeaveDateSelected = [...this.addLeaveService.weeklyLeaveList, ...this.addLeaveService.biWeeklyLeaveList, ...this.addLeaveService.monthlyLeaveList]?.find(leave => leave.leaveDate === this.daysSelected[0])
      data.options = isRecurringLeaveDateSelected !== undefined ? ['Occurence', 'Series'] : ['Ok'];
      width = isRecurringLeaveDateSelected !== undefined ? '32rem' : '400px';
      data.popupTitle = this.translate.instant('servicePersonnel.addNewLeave');
      data.popupBodyText = this.translate.instant('teamManagement.areYouSureDoYouWantToDelete');

    } else {
      data.popupTitle = this.translate.instant('servicePersonnel.selectTheEndDateOptionalTxt');
      data.popupBodyText = " ";
      data.options = [];
      data.dateSelected = daySelected;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width,
      height: '250px',
      data,
      panelClass: 'asp-modal-container'
    });
    this.subs.dialog = dialogRef.afterClosed().subscribe((result) => {

      if (result?.action === 'confirm' && key === 'delete') {
        /* ---------------  delete leaves  ----------------*/
        for (const daySelected of this.daysSelected) {
        const isSelectedDayLeave = [...this.addLeaveService.weeklyLeaveList,...this.addLeaveService.biWeeklyLeaveList,...this.addLeaveService.monthlyLeaveList].find(leave=>{
            return leave.leaveDate === daySelected
          })
          if(isSelectedDayLeave){
            this.addLeaveService.exceptionalList.push(isSelectedDayLeave);
          }
        }
        for (const daySelected of this.daysSelected) {
          this.addLeaveService.addLeaveExceptionalList( daySelected, result.data.option.toLowerCase())
        }

        if(this.data?.employee?.avatar === "undefined" || !this.data?.employee?.avatar){
          this.data = {
             ...this.data,
             employee: {
              ...this.data.employee,
              avatar: ''
             }
          };
        }

        const employee: IEmployee = {
          ... this.data.employee,
          employeeLeaveDetails: [...this.addLeaveService.leaveDetailsYearWise]
        }
        this.dispatchActions(employee);
        this.data = { employee: employee }
        this.addLeaveService.resetValues();
        this.addLeaveService.getEmployeeLeaveDetails(this.data, this.minDate);
        this.daysSelected = [];
        this.isDeleteButtonEnable = true;
        this.calendar.updateTodaysDate();
      }
      if (result?.action === 'confirm' && key === 'save') {
        /* ---------------  save leaves  ----------------*/
        this.saveEmployeeLeaveDetails(result.data);
      }
    })
  }
  private enableDeleteButton() {
    const filteredArray = [];
    const newArray = [...this.addLeaveService.trainingList, ...this.addLeaveService.dayOffList, ...this.addLeaveService.weeklyLeaveList, ...this.addLeaveService.biWeeklyLeaveList, ...this.addLeaveService.monthlyLeaveList];
    newArray.forEach(value => {
      if (this.daysSelected.find(element => element === value.leaveDate)){
        filteredArray.push(value.leaveType);
      }
    });
    return filteredArray;
  }
  ngOnDestroy() {
    this.addLeaveService.resetValues();
    this.daysSelected = [];
    this.addLeaveService.leaveDetailsYearWise = [];
    this.addLeaveService.recurrentLeaveList = [];
    unsubscribeSubscriptions(this.subs);
  }
  monthChange(event) {
    this.addLeaveService.weeklyLeaveList = [...this.addLeaveService.weeklyLeaveList];
    this.addLeaveService.monthlyLeaveList = [...this.addLeaveService.monthlyLeaveList];
    this.addLeaveService.biWeeklyLeaveList = [...this.addLeaveService.biWeeklyLeaveList];
  }

  getTranslation(name){
    return name ? this.translate.instant(`common.${name}`) : name
  }
}
